module.exports = __webpack_public_path__ + "img/busca-avancada-uso-florestal-2.a68c7b9f.jpg";